/* eslint-disable no-undef */

const TAG = 'FBQ';

function track(event, data = {}) {
  try {
    fbq('track', event, data);
  } catch (error) {
    setTimeout(() => {
      try {
        fbq('track', event, data);
      } catch (e) {
        console.log(TAG, event, error);
      }
    }, 3000);
  }
}

const FacebookPixel = {
  pageView() {
    track('PageView');
  },

  productView(id, name, price, currency) {
    track('ViewContent', {
      content_ids: [id],
      content_name: name,
      value: price,
      currency,
      content_type: "product",
    });
  },

  cartItemAdd(id, name, price, currency) {
    track('AddToCart', {
      content_ids: [id],
      content_name: name,
      value: price,
      currency,
      content_type: "product",
    });
  },

  checkoutInit(price, currency, items) {
    let numberOfItems = 0;
    const skus = items.map(item => {
      numberOfItems += item.quantity;
      return item.id;
    });
    track('InitiateCheckout', {
      content_ids: skus,
      contents: items.map(item => ({ id: item.id, quantity: item.quantity })),
      num_items: numberOfItems,
      value: price,
      currency: currency.toUpperCase(),
    });
  },

  // orderPaymentAdd() {
  //   track('AddPaymentInfo');
  // },

  orderSend(price, currency, externalOrderId, items) {
    let numberOfItems = 0;
    const skus = items.map(item => {
      numberOfItems += item.quantity;
      return item.id;
    });

    track('Purchase', {
      value: price,
      currency: currency.toUpperCase(),
      order_id: externalOrderId,
      content_ids: skus,
      num_items: numberOfItems,
      content_type: "product"
    });
  },
};

export default FacebookPixel;
